import React, { useEffect, useRef, useState } from 'react'
import { Button, Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import ImgTrainingbanner from "../../../assets/Image/ImgProduct/Training-bg.png";
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import AOS from "aos";
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import { i18n } from 'i18n';

import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import usePagination from "components/Pagination/Pagination";
import CardImage from 'components/CardImage/CardImage';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';

const i18nField = 'entities.PublicProductService.fields';


const Training = () => {


    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const Layout900 = useMediaQuery('(min-width:900px)');
    const onsiteRef = useRef<HTMLDivElement>(null);

    const navigate = useNavigate();

    const PER_PAGE = 8;
    const [lstOnsite, setlstOnsite] = useState([] as any)
    let [page, setPage] = useState(1);
    const count = Math.ceil(lstOnsite.length / PER_PAGE);
    const _DATA = usePagination(lstOnsite, PER_PAGE);

    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
        GetTraining();

    }, [])

    const GetTraining = () => {
        BlockUI()
        AxiosGet(`Training/GetTraining`, { "sLanguage": currentLanguage() }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                let result = res?.result?.data;
                if (result) {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                    });
                    setlstOnsite(result || [])
                }
            })
        });
    }

    const handleChange = (e, p) => {
        setPage(p);
        _DATA.jump(p);
        // ToRef();
    };

    const ToRef = () => {
        if (onsiteRef && onsiteRef.current) {
            window.scrollTo({ behavior: 'smooth', top: onsiteRef.current.offsetTop-64 })
        }
    };

    const pageNext = () => {
        return <span onClick={ToRef}>Next</span>;
    };

    const pagePrevious = () => {
        return <span onClick={ToRef}>Previous</span>;
    };


    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: !Layout900 ? '50%' : '40%', left: '10%' }}>
                    <Typography style={{ lineHeight: "1", color: '#ffffff' }}>
                        <span style={{ fontWeight: "400", display: "flex", fontSize: !Layout900 ? "1.4em" : "3em" }}>
                            Onsite Training
                        </span>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                            <Grid item>
                                <Link to="/Home" preventScrollReset={true}>
                                    <span style={{ fontWeight: "400", color: '#ffffff', fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                        {i18n(`${i18nField}.sHomepage`)}
                                    </span>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Divider orientation='vertical' style={{ height: '30px', backgroundColor: '#ffffff' }} />
                            </Grid>
                            <Grid item>
                                <span style={{ fontWeight: "400", fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                    <b>  {i18n(`${i18nField}.sVOC2`)}</b>
                                </span>
                            </Grid>
                        </Grid>
                    </Typography>
                </div>
                <img src={ImgTrainingbanner} alt='' style={{ width: '100%', minHeight: '250px', objectFit: 'cover' }} />
            </div>
            <div ref={onsiteRef} style={{ padding: !Layout900 ? '1em' : '2em 5em' }}>
                <Grid container spacing={4} direction="row" justifyContent="center" alignItems="start" style={{ marginBottom: '1em' }}>
                    <Grid item xs={12}>
                        <Grid container direction="row" justifyContent={"start"} alignItems={"center"}>
                            {
                                (_DATA.currentData()).length > 0
                                    ?
                                    <>
                                        {
                                            (_DATA.currentData()).map((item, idx) => {
                                                return (
                                                    <Grid key={`os-${idx}`} className="box-training" item xs={12} sm={6} md={4} lg={3} >
                                                        <Grid container spacing={2} direction="row" justifyContent={"start"} alignItems={"center"}>
                                                            <Grid item xs={12}>
                                                                <CardImage
                                                                    src={item.sFileLink}
                                                                    alt={""}
                                                                    width={"100%"}
                                                                    height={"250px"}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography className='title-intro-product' style={{ fontSize: '1.5em', fontWeight: 500 }}>
                                                                    {item?.sTrainingName}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} >
                                                                <Typography className='detail-intro-product' style={{ fontSize: '1em', fontWeight: 500 }}>
                                                                    {item?.sIntroduce}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={12} >
                                                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                                                                    <Grid item >
                                                                        <Button
                                                                            variant="outlined"
                                                                            size="large"
                                                                            style={{ backgroundColor: '#1773ea', border: 'none', color: '#ffffff', borderRadius: '25px', padding: '4px 16px' }}
                                                                            startIcon={<ArrowForwardIosRoundedIcon style={{ color: '#ffffff' }} />}
                                                                            onClick={() => { 
                                                                                let StrUrl = "/Front/DetailTraining?sID=" + item?.sTrainingID;
                                                                                navigate(StrUrl)
                                                                                // navigate(StrUrl,
                                                                                // {
                                                                                //     state:
                                                                                //     {
                                                                                //         sTrainingID: item?.sTrainingID,
                                                                                //         sTypeID: "3", //1 = Product, 2 = Service, 3 = Training
                                                                                //     }
                                                                                // })
                                                                            }}
                                                                        >
                                                                            {i18n(`${i18nField}.sRead`)}
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )
                                            })}
                                    </>
                                    :
                                    null
                            }
                        </Grid>
                    </Grid>
                    {
                        (_DATA.currentData()).length > 0
                            ?
                            <Grid item xs={12}>
                                <Stack spacing={2} style={{ margin: "1rem auto 2rem", alignItems: "center" }}>
                                    <Pagination
                                        count={count}
                                        page={page}
                                        onChange={handleChange}
                                        color="primary"
                                        renderItem={(item) => <PaginationItem components={{ previous: pagePrevious, next: pageNext }} {...item} />}
                                    />
                                </Stack>
                            </Grid>
                            : 
                            <Grid item xs={12}>
                                <Typography style={{ fontSize: '1em', fontWeight: 500, textAlign:'center' }}>
                                    {currentLanguage() == "th" ? "ไม่พบข้อมูล" : "No data"}
                                </Typography>
                            </Grid>
                    }
                </Grid>
            </div>

        </>
    )
}

export default Training